export default "__VITE_ASSET__BNihPpel__"